/**
 * Embedded Shareable Collection Theme Configuration
 * 
 * To customize this app for your brand, change the color values below.
 * All colors use standard hex color codes (e.g., #FF5733 or #000000)
 * 
 */

export const theme = {
  // Primary Brand Colors
  primary: '#007bff',           // Main brand color (buttons, links, highlights)
  primaryDark: '#0056b3',       // Darker shade for hover states
  primaryLight: '#66b3ff',      // Lighter shade for backgrounds

  // Secondary Colors
  secondary: '#6c757d',         // Secondary actions, borders
  secondaryDark: '#545b62',
  secondaryLight: '#adb5bd',

  // Background Colors
  background: '#ffffff',        // Main page background
  surface: '#f8f9fa',          // Card/panel backgrounds

  // Text Colors
  text: '#212529',             // Main text color
  textSecondary: '#6c757d',    // Secondary text
  textMuted: '#adb5bd',        // Muted/disabled text

  // Status Colors
  success: '#28a745',           // Success messages, confirmations
  warning: '#ffc107',           // Warning messages
  error: '#dc3545',            // Error messages, alerts
  info: '#17a2b8',             // Informational messages

  // Border & Divider
  border: '#dee2e6',           // Border color
  divider: '#e9ecef',          // Divider lines

  // Interactive States
  hover: '#f8f9fa',            // Hover background
  active: '#e9ecef',           // Active/pressed state
  disabled: '#e9ecef',         // Disabled elements

  // Branding
  brandName: 'My App',         // Your brand/company name
  logo: '/logo.svg',           // Path to your logo file

  // Homepage Content
  exploreTitle: 'Explore Sharable Collections',  // Main title on homepage
  exploreDescription: 'Browse through all available sharable collections below. Each collection contains unique NFTs ready to explore.',  // Description text on homepage
};
